var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"element-player-modal",attrs:{"id":"element-player-modal","title":"","size":"700"},on:{"show":_vm.loadScript}},[_c('div',[_vm._v(" Test ")])])}
var staticRenderFns = []

export { render, staticRenderFns }